import { createStore } from "redux";
import { combineReducers } from "redux";
import UserInfoReducer from "./reducers/UserInfoReducer";
import ProjectsReducer from "./reducers/ProjectsReducer";
import UpdateCommandsReducer from "./reducers/UpdateCommandsReducer";
import UsersReducer from "./reducers/UsersReducer";
import CounterTypeReducer from "./reducers/CounterTypeReducer";
import CountersReducer from "./reducers/CountersReducer";
import StatisticsReducer from "./reducers/StatisticsReducer";
import ProjectsByCitiesReducer from "./reducers/projectsByCitiesRducer";
import TypesInfoReducer from "./reducers/TypesInfoReducer";
import AdminProfileReducer from "./reducers/AdminProfileReducer";
import CounterCategoriesReducer from "./reducers/CounterCategoriesReducer";
import ComponentStatesReducer from "./reducers/ComponentStatesReducer";
import NavigationReducer from "./reducers/NavigationReducer";

const rootReducer = combineReducers({
  user: UserInfoReducer,
  projects: ProjectsReducer,
  updateCommands: UpdateCommandsReducer,
  users: UsersReducer,
  counterTypes: CounterTypeReducer,
  counters: CountersReducer,
  statistics: StatisticsReducer,
  projectsByCities: ProjectsByCitiesReducer,
  typesInfo: TypesInfoReducer,
  adminProfile: AdminProfileReducer,
  categories: CounterCategoriesReducer,
  componentStates: ComponentStatesReducer,
  navigations: NavigationReducer,
});

const store = createStore(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store;
